import type * as lazyIndex from './lazyIndex';
import type { NeedsReplyBarProps } from './components/NeedsReplyBar';
import type { NeedsReplyViewHeaderButtonsProps } from './components/NeedsReplyViewHeaderButtons';
import { createLazyComponent, type LazyComponent, LazyAction, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "MailNeedsReply"*/ './lazyIndex'),
    { name: 'MailNeedsReply' }
);

export const NeedsReplyBar: LazyComponent<NeedsReplyBarProps, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.NeedsReplyBar
);

export const NeedsReplyViewHeaderButtons: LazyComponent<
    NeedsReplyViewHeaderButtonsProps,
    unknown,
    void
> = createLazyComponent(lazyModule, m => m.NeedsReplyViewHeaderButtons);

export const lazyOpenNeedsReplyView: LazyAction<
    typeof lazyIndex.openNeedsReplyView,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.openNeedsReplyView);
